var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "scrollContainer", staticClass: "app-install" }, [
    _c("h2", [
      _vm._v("\n    App-Installation\n    "),
      _c("span", { staticClass: "badge" }, [_vm._v(_vm._s(_vm.platformLabel))]),
      _vm._v(" "),
      _vm.lang
        ? _c("span", { staticClass: "badge" }, [
            _vm._v("Sprache: " + _vm._s(_vm.lang))
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "hint" },
      [
        _vm.running
          ? [
              _vm._v(
                "\n      Installiere " +
                  _vm._s(_vm.done) +
                  " von " +
                  _vm._s(_vm.total) +
                  " …\n    "
              )
            ]
          : _vm.finished
          ? [
              _vm._v(
                "\n      Fertig: " +
                  _vm._s(_vm.countInstalled) +
                  " installiert, " +
                  _vm._s(_vm.countFailed) +
                  " fehlgeschlagen,\n      " +
                  _vm._s(_vm.countSkipped) +
                  " uebersprungen.\n      "
              ),
              _c("br"),
              _vm._v(
                "GRUEN = erneut versuchen, ROT/ZURUECK = zurueck zur Info-Seite.\n    "
              )
            ]
          : _vm.loading
          ? [_vm._v("\n      Ermittle Zustand der Apps …\n    ")]
          : [
              _vm._v("\n      " + _vm._s(_vm.summary) + "\n      "),
              _c("br"),
              _vm._v(
                "GELB = Installation starten, GRUEN = Zustand neu einlesen,\n      ROT/ZURUECK = zurueck zur Info-Seite.\n    "
              )
            ]
      ],
      2
    ),
    _vm._v(" "),
    _vm.diagLines.length
      ? _c(
          "div",
          { staticClass: "diag" },
          [
            _c("div", { staticClass: "diag-title" }, [
              _vm._v("Geraete-Diagnose")
            ]),
            _vm._v(" "),
            _vm._l(_vm.diagLines, function(line) {
              return _c(
                "div",
                {
                  key: line.label,
                  staticClass: "diag-line",
                  class: "diag-" + line.level
                },
                [
                  _c("span", { staticClass: "diag-label" }, [
                    _vm._v(_vm._s(line.label))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "diag-value" }, [
                    _vm._v(_vm._s(line.value))
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm.blockingHint
              ? _c("div", { staticClass: "diag-note" }, [
                  _vm._v(_vm._s(_vm.blockingHint))
                ])
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.rows.length
      ? _c(
          "table",
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.rows, function(row) {
              return _c(
                "tr",
                { key: row.group + row.key, staticClass: "row" },
                [
                  _c("td", { staticClass: "col-name" }, [
                    _vm._v("\n        " + _vm._s(row.name)),
                    _c("span", { staticClass: "group" }, [
                      _vm._v(" · " + _vm._s(row.group))
                    ]),
                    row.lang
                      ? _c("span", { staticClass: "lang" }, [
                          _vm._v(" · " + _vm._s(row.lang))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-id" }, [
                    _vm._v(
                      "\n        " + _vm._s(row.appId || "(über den Namen)")
                    ),
                    row.resolvedAppId && row.resolvedAppId !== row.appId
                      ? _c("span", { staticClass: "resolved" }, [
                          _c("br"),
                          _vm._v("→ am Gerät: " + _vm._s(row.resolvedAppId))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    row.deviceMatches && row.deviceMatches.length > 1
                      ? _c(
                          "span",
                          { staticClass: "variants" },
                          [
                            _c("br"),
                            _vm._v(
                              _vm._s(row.deviceMatches.length) +
                                " Varianten am Gerät:\n          "
                            ),
                            _vm._l(row.deviceMatches, function(m) {
                              return _c(
                                "span",
                                { key: m.id },
                                [
                                  _c("br"),
                                  _vm._v("  " + _vm._s(m.id)),
                                  m.name
                                    ? [_vm._v(" — " + _vm._s(m.name))]
                                    : _vm._e(),
                                  m.variant
                                    ? [_vm._v(" (Nebenvariante)")]
                                    : _vm._e()
                                ],
                                2
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "col-state", class: "state-" + row.state },
                    [_vm._v(_vm._s(_vm.stateLabel(row)))]
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-detail" }, [
                    _vm._v(_vm._s(row.detail))
                  ])
                ]
              )
            })
          ],
          2
        )
      : !_vm.loading
      ? _c("div", { staticClass: "hint" }, [
          _vm._v(
            "\n    Keine App-Ziele konfiguriert - fuer die aktive Plattform (" +
              _vm._s(_vm.platformLabel) +
              ")\n    ist in keiner Cast-App eine App-Id hinterlegt.\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "col-name" }, [_vm._v("App")]),
      _vm._v(" "),
      _c("th", { staticClass: "col-id" }, [_vm._v("App-ID")]),
      _vm._v(" "),
      _c("th", { staticClass: "col-state" }, [_vm._v("Zustand")]),
      _vm._v(" "),
      _c("th", { staticClass: "col-detail" }, [_vm._v("Detail")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73cf64de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73cf64de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppInstall.vue
// module id = null
// module chunks = 